import React, { Component } from "react";

import {
  Modal, DataTable
} from "@shopify/polaris";


// import utils from '../../utils/utils';

import Language from '../../i18n/Language';
const t = Language

class ExportRecordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ExportRecordActive:props.ExportRecordActive,
      recordRows:props.recordRows
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if(nextProps.ExportRecordActive !== this.state.ExportRecordActive) {
      let ExportRecordActive = nextProps.ExportRecordActive;
      this.setState({
        ExportRecordActive: ExportRecordActive,
      })
    }
    if(nextProps.recordRows !== this.props.recordRows){
      this.setState({
        recordRows:nextProps.recordRows
      })
    }
    return true
  }

  CloseExportRecord = () =>{
    this.props.CloseExportRecord()
  }

  render() {
  
    return (
      <div style={{maxHeight: '400px'}} >
        <Modal
          open={this.state.ExportRecordActive}
          onClose={this.CloseExportRecord}
          title={t("Export Records")}
          primaryAction={[
            {
              content: t("Close"),
              onAction: this.CloseExportRecord
            }
          ]}
          
        >
          <Modal.Section>
          
            <DataTable
            columnContentTypes={[
              'text',
              'text',
              'text',
              'text',
              'text',
            ]}
            headings={[
              t("File name"),
              t("Records number"),
              t("Export time"),
              t("Status"),
              '',
            ]}
            rows={this.state.recordRows}
          />
          </Modal.Section>
        </Modal>
      </div>
    );
  }
}

export default ExportRecordModal;